import { RefObject, ChangeEvent } from 'react'
import { ChatHeader } from './ChatHeader'
import { ChatMessages } from './ChatMessages'
import { Message, MessageProps } from './Message'
import { TypingIndicator } from './TypingIndicator'
import { ChatInput } from './ChatInput'
import { QuickActions } from './QuickActions'
import styles from './ChatPanel.module.css'

interface ChatPanelProps {
  messages: MessageProps[]
  isTyping?: boolean
  onSend?: (message: string) => void
  onUploadClick?: () => void
  isUploading?: boolean
  fileInputRef?: RefObject<HTMLInputElement>
  onFileInputChange?: (e: ChangeEvent<HTMLInputElement>) => void
  acceptTypes?: string
}

export function ChatPanel({
  messages,
  isTyping = false,
  onSend,
  onUploadClick,
  isUploading = false,
  fileInputRef,
  onFileInputChange,
  acceptTypes = '.txt,.pdf,.doc,.docx,.rtf,.pages'
}: ChatPanelProps) {
  return (
    <div className={styles.panel}>
      <ChatHeader />
      <ChatMessages>
        {messages.map((msg, i) => (
          <Message key={i} {...msg} />
        ))}
        {isTyping && <TypingIndicator />}
      </ChatMessages>
      <ChatInput
        onSend={onSend}
        onAttachClick={onUploadClick}
        isUploading={isUploading}
      />
      <QuickActions
        onUploadClick={onUploadClick}
        isUploading={isUploading}
      />
      <input
        type="file"
        ref={fileInputRef}
        onChange={onFileInputChange}
        accept={acceptTypes}
        style={{ display: 'none' }}
      />
    </div>
  )
}
